import React from 'react';
import publications from '../research/publications';
import Publication from '../research/Publication';
import ongoingworks from '../research/ongoingworks';
import OngoingWork from '../research/OngoingWork';
import Page from './Page';

const Research = () => {
  const publicationNodes = publications.map(
    (
      {
        title,
        paperUrl,
        repoUrl,
        thumbnailSource,
        authors,
        status,
        venue,
        citation,
      },
      index
    ) => (
      <Publication
        title={title}
        paperUrl={paperUrl}
        repoUrl={repoUrl}
        thumbnailSource={thumbnailSource}
        authors={authors}
        status={status}
        venue={venue}
        citation={citation}
        key={title}
        className={index < publications.length - 1 ? 'mb-4' : ''}
      />
    )
  );

  const ongoingWorkNodes = ongoingworks.map(
    ({ title, description, authors }, index) => (
      <ul>
        <li>
          <OngoingWork
            title={title}
            description={description}
            authors={authors}
            className={index < publications.length - 1 ? 'mb-4' : ''}
          />
        </li>
      </ul>
    )
  );

  return (
    <Page title="Research">
      <div className="mb-4">
        <h2>Publications</h2>
        {publicationNodes}
      </div>
      <div className="mb-4">
        <h2>Ongoing Research</h2>
        {ongoingWorkNodes}
      </div>
    </Page>
  );
};

export default Research;
